import type { FaireProductEntity } from "../../entity_types/product";

export const p_dgtf9kqfhc: FaireProductEntity = {
  token: "p_dgtf9kqfhc",
  type: "product",
  name: "Ssamjang Korean Barbeque Sauce",
  brandToken: "b_mkwgw6t63p",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.faire.com/fastly/04cb0570f9f1664358a9b87964efead5f2df87263ddfae75e135af30474569db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49445ed8f2aa6bd6ad9376ba27472e8f5b70b960878197a127bf1e909da07c65.jpeg",
    "https://cdn.faire.com/fastly/3119425c549d016913ba7681498db38c08ea43e825d21abe329fe48bb62f6c47.jpeg",
    "https://cdn.faire.com/fastly/ea5853c673b868b22d692aec392eff76fd7885d9b30d9252bcbf4ae26ba3a42c.jpeg",
    "https://cdn.faire.com/fastly/84acd3e3a4333f4fb17498bca8286cd795a8ccf1862741b67ffd26e6ef352a5e.jpeg",
    "https://cdn.faire.com/fastly/3ac0447024f0f1202ac38274f43c70ad834ce23454868403fb2eae8b942ba0b6.jpeg",
    "https://cdn.faire.com/fastly/aa0b98e0b0b28f88669b1b19fcb753472aedf70ada323959ea16e490109a1913.jpeg",
    "https://cdn.faire.com/fastly/056a86483976c4249ac2d16e268dff19df972446cc919d3c7ca004abd8e19a6b.png",
  ],
  priceDollars: 8,
  description:
    "SSAM 쌈 [WRAPPED] + JANG 장 [SAUCE OR PASTE]\nA concentrated, no-cook, stir-together sauce that’s equal parts savory funk and sweet heat. This Korean barbeque mainstay is perfect for dipping and dabbing. Pairs well with grilled meats, raw veggies, bibimbap and dumplings. A little goes a long way.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:24.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
